import { ButtonBase, Stack } from "@mui/material"
import { colors } from "../../services/config/colors"
import Title from "../global/common/Title"
import arrowLefIcon from "../../assets/icons/arrow-left.svg"
import { useNavigate } from "react-router-dom"
import Text from "../global/common/Text"
import AppearFromSide from "../animations/AppearFromSide"
import Tabs from "../global/common/Tabs"
import { useContext, useState } from "react"
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next"
import { MainContext } from "../../controllers/main"
import LeaderboardTop3 from "../performance/common/LeaderboardTop3"
import LeaderboardListItem from "../performance/common/LeaderboardListItem"
import rocket from "../../assets/icons/rocket.svg"
import communityIcon from "../../assets/icons/community.svg"
import SavingCard from "../actions/common/SavingCard"
import { CommunityContext } from "../../controllers/community"

const CommunityMobile = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useContext(MainContext)
  const { community } = useContext(CommunityContext)

  // tabs
  const tabs = [t("overview"), t("leaderboard")]
  const [selectedTab, setSelectedTab] = useState<number>(0)

  return (
    <Stack
      style={{
        width: "100%",
        minHeight: "100%",
        backgroundColor: colors.backgroundWhite,
        paddingTop: 22,
        overflowX: "hidden",
      }}
    >
      {/* header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        style={{ width: "100%", height: 48, paddingInline: 16 }}
      >
        <ButtonBase
          style={{
            width: 48,
            minWidth: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 12,
          }}
          onClick={() => {
            navigate("/", { state: { fromPerformance: true } })
          }}
          aria-label={t("go_back")}
        >
          <img src={arrowLefIcon} style={{ width: 15 }} alt="" />
        </ButtonBase>
        <Title
          fontSize={20}
          lineHeight="23px"
          style={{ height: 23, fontStyle: "italic" }}
          component="h1"
          color={colors.primary}
        >
          {t("community").toUpperCase()}
        </Title>
        <div
          style={{
            width: 48,
            minWidth: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 12,
          }}
        />
      </Stack>
      {/* tabs */}
      <AppearFromSide
        fade
        style={{
          marginTop: 20,
        }}
      >
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          tabContentId="community-tabs-content"
        />
      </AppearFromSide>
      {/* tabs content */}
      <AppearFromSide delay={0.05} fade style={{ marginTop: 25 }}>
        <motion.div
          animate={selectedTab.toString()}
          variants={tabs.reduce(
            (obj, current, index) => ({
              ...obj,
              [index]: {
                x: `calc(-100vw * ${index})`,
              },
            }),
            {}
          )}
          transition={{ x: { type: "spring", damping: 18, stiffness: 160 } }}
          initial={false}
        >
          <Stack
            id="community-tabs-content"
            direction="row"
            style={{
              width: "300vw",
              minWidth: "300vw",
              marginBottom: 26,
            }}
            role="tabpanel"
          >
            {/* overview */}
            <Stack
              style={{
                width: "100vw",
                minWidth: "100vw",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                style={{
                  width: "100%",
                  height: 30,
                  position: "relative",
                  paddingInline: 16,
                }}
              >
                <Title fontSize={18} lineHeight="24px" component="h2">
                  {t("overview")}
                </Title>
              </Stack>
              <Stack
                gap={2}
                direction="row"
                style={{ marginTop: 18, paddingInline: 16 }}
              >
                <Stack
                  alignItems="center"
                  style={{
                    width: "100%",
                    height: 130,
                    borderRadius: 16,
                    border: "1px solid " + colors.primary,
                    backgroundColor: colors.backgroundWhite,
                    paddingTop: 18,
                  }}
                >
                  <img src={communityIcon} style={{ height: 22 }} alt="" />
                  <Title
                    fontSize={18}
                    lineHeight="20px"
                    color={colors.primary}
                    style={{ marginTop: 16 }}
                  >
                    {community?.userCount}
                  </Title>
                  <Text
                    fontSize={14}
                    lineHeight="16px"
                    fontWeight={400}
                    textAlign="center"
                    style={{ marginTop: 5, width: 100 }}
                  >
                    {t("total_participants")}
                  </Text>
                </Stack>
                <Stack
                  alignItems="center"
                  style={{
                    width: "100%",
                    height: 130,
                    borderRadius: 16,
                    border: "1px solid " + colors.primary,
                    backgroundColor: colors.backgroundWhite,
                    paddingTop: 18,
                  }}
                >
                  <img src={rocket} style={{ height: 22 }} alt="" />
                  <Title
                    fontSize={18}
                    lineHeight="20px"
                    color={colors.primary}
                    style={{ marginTop: 16 }}
                  >
                    {community?.totalMissions}
                  </Title>
                  <Text
                    fontSize={14}
                    lineHeight="16px"
                    fontWeight={400}
                    textAlign="center"
                    style={{ marginTop: 5, width: "100%" }}
                  >
                    {t("total_completed_missions")}
                  </Text>
                </Stack>
              </Stack>
              <Title
                fontSize={18}
                lineHeight="24px"
                component="h2"
                style={{ marginTop: 24, paddingInline: 16 }}
              >
                {t("description")}
              </Title>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 300,
                  color: colors.text,
                  paddingInline: 16,
                  marginTop: 16,
                }}
                dangerouslySetInnerHTML={{
                  __html: t("community_description"),
                }}
              />
              {community &&
              community.savings &&
              (community.savings.co2Saving ||
                community.savings.waterSaving ||
                community.savings.energySaving) ? (
                <div style={{ width: "100%", marginTop: 24 }}>
                  <Stack>
                    <Title
                      fontSize={18}
                      lineHeight="25px"
                      paddingLeft={16}
                      component="h2"
                    >
                      {t("total_community_savings")}*
                    </Title>
                    <Stack
                      direction="row"
                      gap={1.5}
                      style={{
                        width: "100%",
                        overflowX: "scroll",
                        paddingInline: 16,
                        marginTop: 16,
                      }}
                    >
                      {community.savings.co2Saving ? (
                        <SavingCard
                          metric="co2"
                          amount={community.savings.co2Saving}
                        />
                      ) : null}
                      {community.savings.waterSaving ? (
                        <SavingCard
                          metric="water"
                          amount={community.savings.waterSaving}
                        />
                      ) : null}
                      {community.savings.energySaving ? (
                        <SavingCard
                          metric="energy"
                          amount={community.savings.energySaving}
                        />
                      ) : null}
                    </Stack>
                    <Text
                      fontSize={14}
                      fontWeight={400}
                      style={{ marginTop: 16, paddingInline: 16 }}
                    >
                      *L’impatto ambientale totale è calcolato sull’intera
                      durata della community.
                    </Text>
                  </Stack>
                </div>
              ) : null}
            </Stack>
            {/* leaderboard */}
            <Stack
              style={{ width: "100vw", minWidth: "100vw", paddingInline: 16 }}
            >
              <Stack
                direction="row"
                alignItems="center"
                style={{ width: "100%", height: 30, position: "relative" }}
              >
                <Title fontSize={18} lineHeight="24px" component="h2">
                  {t("leaderboard")}*
                </Title>
              </Stack>
              <LeaderboardTop3
                leaderboard={community!.bestUsers}
                style={{ marginTop: 18 }}
              />
              {community!.bestUsers.length > 3 ? (
                <Stack
                  id="leaderboard-container"
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: 224,
                    borderRadius: 10,
                    marginTop: 28,
                    boxShadow: "0px 0px 24px 0px rgba(17, 67, 97, 0.08)",
                    overflowY: "scroll",
                    position: "relative",
                  }}
                >
                  {community!.bestUsers.slice(3).map((item, index) => (
                    <Stack key={index} style={{ height: 56, minHeight: 56 }}>
                      <div
                        style={{
                          width: "100%",
                          height: 1.5,
                          backgroundColor:
                            !index && item.sub !== user!.sub
                              ? colors.backgroundWhite
                              : colors.backgroundLight,
                        }}
                      />
                      <LeaderboardListItem
                        place={item.position}
                        name={`${item.first_name} ${item.last_name}`}
                        points={item.points}
                        isUser={item.sub === user!.sub}
                        profileImage={item.profileImage}
                        height={54.5}
                      />
                    </Stack>
                  ))}
                </Stack>
              ) : (
                <Text fontSize={14} fontWeight={400} style={{ marginTop: 18 }}>
                  {t("leaderboard_empty_state")}.
                </Text>
              )}
              <Text fontSize={14} fontWeight={400} style={{ marginTop: 22 }}>
                *La classifica mostra gli utenti più virtuosi dalla nascita
                della community.
              </Text>
            </Stack>
          </Stack>
        </motion.div>
      </AppearFromSide>
    </Stack>
  )
}

export default CommunityMobile
